import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, Role } from './auth.service';

export function homeFor(role: Role | null): string {
  return role === 'Admin' ? '/admin' : role === 'Service' ? '/service' : '/helper';
}

function requireRole(required: Role): CanActivateFn {
  return async () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    // Wait for the persisted session to be restored before deciding, so a
    // reload of a protected route doesn't bounce to /login on a cold start.
    await auth.ready;
    if (!auth.isAuthenticated()) return router.createUrlTree(['/login']);
    if (auth.role() === required) return true;
    // logged in as the other role → send to their shell
    return router.createUrlTree([homeFor(auth.role())]);
  };
}

export const helperGuard: CanActivateFn = requireRole('Helper');
export const adminGuard: CanActivateFn = requireRole('Admin');
export const serviceGuard: CanActivateFn = requireRole('Service');

/** An Admin acting as a helper is already that helper: picking another would send X-Act-As for
 *  one helper while request bodies carry another's helperId. */
export const notActingAsHelperGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  await auth.ready;
  return auth.actingAs()?.role === 'Helper' ? router.createUrlTree(['/helper/agenda']) : true;
};
